// assets/js/mega-menu.js (clean/prod)
(function () {
  function boot() {
    try {
      const triggers = document.querySelectorAll('.js-mega-trigger');
      const overlay  = document.getElementById('megamenu');
      const frame    = document.getElementById('mega-frame');
      const content  = document.getElementById('mega-content');
      const header   = document.querySelector('header');

      if (!overlay || !frame || !content || !triggers.length) return;

      let hideTimer, outsideTimer, idleClearTimer;

      // ✅ Anti “micro scroll” (Magic Mouse / trackpad)
      let ignoreScrollUntil = 0;
      let wheelLockEnabled = false;

      /* ---------------- helpers ---------------- */

      function isOpen() {
        return overlay && !overlay.classList.contains('invisible');
      }

      function getTemplateHTML(id) {
        const el = document.getElementById(id);
        if (!el) return '';
        const tag = el.tagName.toLowerCase();

        if (tag === 'template') {
          const s1 = (el.content && el.content.innerHTML) || '';
          const s2 = el.innerHTML || '';
          const s3 = (el.content && el.content.firstElementChild && el.content.firstElementChild.outerHTML) || '';
          return (s1 && s1.trim()) || (s2 && s2.trim()) || (s3 && s3.trim()) || '';
        }
        return (el.innerHTML || '').trim();
      }

      function computeGeometry() {
        const ref =
          document.querySelector('header .container') ||
          document.querySelector('.container') ||
          header;

        if (!overlay || !frame || !ref) return;

        const r = ref.getBoundingClientRect();

        // IMPORTANT : pas d’espace cliquable entre nav et overlay
        overlay.style.top  = r.bottom + 'px';
        frame.style.left   = r.left + 'px';
        frame.style.width  = r.width + 'px';

        // Écart visuel dans le panneau, sans gap de hover
        frame.style.marginTop = '10px';
      }

      function showMega() {
        computeGeometry();
        overlay.classList.remove('invisible', 'opacity-0', 'pointer-events-none');
        overlay.setAttribute('aria-hidden', 'false');
      }

      function hideMega() {
        overlay.classList.add('opacity-0');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.addEventListener(
          'transitionend',
          () => overlay.classList.add('invisible', 'pointer-events-none'),
          { once: true }
        );
      }

      function insideMega(target) {
        return !!(
          target &&
          (target.closest('header') ||
            target.closest('#megamenu') ||
            target.closest('#mega-frame') ||
            target.closest('#mega-content'))
        );
      }

      function lockWheel(enable) {
        if (wheelLockEnabled === enable) return;
        wheelLockEnabled = enable;

        // garder la même ref pour removeEventListener
        lockWheel._prevent =
          lockWheel._prevent ||
          function (e) {
            if (!isOpen()) return;
            // Ne bloque que dans la zone menu/header
            if (insideMega(e.target)) e.preventDefault();
          };

        const opts = { passive: false };

        if (enable) {
          document.addEventListener('wheel', lockWheel._prevent, opts);
          document.addEventListener('touchmove', lockWheel._prevent, opts);
        } else {
          document.removeEventListener('wheel', lockWheel._prevent, opts);
          document.removeEventListener('touchmove', lockWheel._prevent, opts);
        }
      }

      // état actif root
      function setActiveTrigger(trigger) {
        triggers.forEach((t) => {
          const active = t === trigger;
          t.classList.toggle('is-active', active);
          if (active) t.setAttribute('aria-current', 'page');
          else t.removeAttribute('aria-current');
        });
      }

      function clearActiveTriggers() {
        triggers.forEach((t) => {
          t.classList.remove('is-active');
          t.removeAttribute('aria-current');
        });
      }

      function bindCol2Hover() {
        const col2 = content.querySelector('.mega-col2');
        const col3 = content.querySelector('#mega-col3');
        if (!col2 || !col3) return;

        const col2Items = col2.querySelectorAll('.js-col2-item');

        function swap(tplId) {
          const tpl = tplId ? document.getElementById(tplId) : null;
          col3.innerHTML = '';
          if (!tpl) return;

          if (tpl.content) col3.appendChild(tpl.content.cloneNode(true));
          else col3.innerHTML = tpl.innerHTML || '';
        }

        function setActiveCol2(aEl) {
          col2Items.forEach((x) => {
            const active = x === aEl;
            x.classList.toggle('is-active', active);
            if (active) x.setAttribute('aria-current', 'true');
            else x.removeAttribute('aria-current');
          });
        }

        function clearActiveCol2() {
          col2Items.forEach((x) => {
            x.classList.remove('is-active');
            x.removeAttribute('aria-current');
          });
        }

        function clearCol3() {
          col3.innerHTML = '';
        }

        // Survol / focus sur chaque item Col2
        col2Items.forEach((a) => {
          const hasChildren = a.getAttribute('data-has-children') === '1';

          function handleEnter() {
            // FIX : si colonne 3 est en mode CMS, ne pas effacer le contenu
            const rootMega = a.closest('[data-mega-mode]');
            const col3Mode = rootMega ? rootMega.dataset.megaMode : 'mirror_children';
            const isCmsMode = col3Mode === 'cms_block';

            col2.classList.add('is-dimming');

            if (!isCmsMode && hasChildren && a.dataset.col3Tpl && document.getElementById(a.dataset.col3Tpl)) {
              swap(a.dataset.col3Tpl);
              setActiveCol2(a);
            } else {
              if (!isCmsMode) {
                clearCol3();
                clearActiveCol2();
              }
            }
          }

          a.addEventListener('mouseenter', handleEnter);
          a.addEventListener('focus', handleEnter);
        });

        // Nettoyage quand on quitte Col2/Col3
        function maybeClear() {
          clearTimeout(idleClearTimer);
          idleClearTimer = setTimeout(() => {
            const overCol2 = document.querySelector(':hover .mega-col2');
            const overCol3 = document.querySelector(':hover #mega-col3');
            if (!overCol2 && !overCol3) {
              col2.classList.remove('is-dimming');
              clearCol3();
              clearActiveCol2();
            }
          }, 120);
        }

        col2.addEventListener('mouseleave', maybeClear);
        col3.addEventListener('mouseleave', maybeClear);
        col2.addEventListener('mouseenter', () => clearTimeout(idleClearTimer));
        col3.addEventListener('mouseenter', () => clearTimeout(idleClearTimer));
      }

      /* ---------------- open/close ---------------- */

      function openMega(id, trigger) {
        const html = getTemplateHTML(id);
        if (!html) return;

        content.innerHTML = html;
        showMega();

        // ✅ Cooldown: ignore momentum scroll juste après l’ouverture
        ignoreScrollUntil = Date.now() + 350;

        // ✅ Bloque le scroll quand on est dans la zone header/mega
        lockWheel(true);

        triggers.forEach((t) => t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false'));
        setActiveTrigger(trigger);
        bindCol2Hover();
      }

      function closeMega() {
        if (!isOpen()) return;

        hideMega();
        lockWheel(false);

        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        clearActiveTriggers();
      }

      /* ---------------- bindings ---------------- */

      triggers.forEach((t) => {
        const id = t.dataset.megaId;
        if (!id) return;

        t.addEventListener('mouseenter', () => openMega(id, t));
        t.addEventListener('focus', () => openMega(id, t));

        t.addEventListener(
          'touchstart',
          (e) => {
            if (!isOpen()) {
              e.preventDefault();
              openMega(id, t);
            }
          },
          { passive: false }
        );
      });

      [header, overlay].forEach((el) => {
        if (!el) return;

        el.addEventListener('mouseleave', () => {
          clearTimeout(hideTimer);
          hideTimer = setTimeout(closeMega, 160);
        });

        el.addEventListener('mouseenter', () => {
          clearTimeout(hideTimer);
        });
      });

      document.addEventListener('mousemove', (e) => {
        clearTimeout(outsideTimer);
        outsideTimer = setTimeout(() => {
          if (isOpen() && !insideMega(e.target)) closeMega();
        }, 260);
      });

      document.addEventListener('click', (e) => {
        if (!insideMega(e.target)) closeMega();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeMega();
      });

      window.addEventListener('resize', computeGeometry);

      // ✅ Scroll: ferme seulement si scroll “volontaire” (pas momentum + pas hover zone)
      window.addEventListener(
        'scroll',
        () => {
          if (!isOpen()) return;

          // Ignore momentum immédiat
          if (Date.now() < ignoreScrollUntil) return;

          // Si on est dans la zone menu/header, ne ferme pas
          const hovered = document.querySelector(':hover');
          if (hovered && insideMega(hovered)) return;

          closeMega();
        },
        { passive: true }
      );

      if (document.fonts?.ready) {
        document.fonts.ready.then(computeGeometry).catch(() => {});
      }

      // expose debug
      window.MEGA = { open: openMega, close: closeMega, geom: computeGeometry };
    } catch (_) {}
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(boot, 0);
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
